var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.advertisements)?_c('div',_vm._l((_vm.advertisements),function(advertisement){return _c('AdCard',{key:advertisement.id,attrs:{"advertisement":advertisement,"centered":_vm.centered,"only-rectangle":_vm.onlyRectangle,"desktop-row":_vm.desktopRow}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }